import { COMPANIES } from '@lx/shared/types';
import { RuntimeEnvironment } from './environment.type';

export const coreEnvironment: RuntimeEnvironment = {
  API_BASE_PATH: 'https://api-dev.klgintdc.com/api',
  API_PRIVATE_BASE_PATH: 'https://api-private-dev.klgintdc.com/dev/api',
  COMPANY: COMPANIES.KAPLAN,
  LOCALE: 'en-US',
  RTL_ENABLED: false,
  production: false,
  environment: null,
  PATH_PREFIX: '',
  FLYWIRE_DEPOSITS_RETURN_URL: '',
};

export const environment = {
  ...coreEnvironment,
};
